import { OptimizedPrismicImage } from '@/components/index';
import type { ImageField, KeyTextField } from '@prismicio/client';
import { memo } from 'react';

import styles from './contentImage.module.scss';

interface ContentImageProps {
  image: ImageField<never>;
  caption: KeyTextField;
}

const ContentImageComponent = ({ image, caption }: ContentImageProps) => {
  return (
    <figure className={styles.figure}>
      <div className={styles.image_wrapper}>
        <OptimizedPrismicImage field={image} className={styles.image} />
      </div>
      <figcaption className={styles.caption}>{caption}</figcaption>
    </figure>
  );
};

export const ContentImage = memo(ContentImageComponent);
